import { SelectField, TextField } from '@measured/puck';

const EXTERNAL_OPTION_VALUE = 'external';
const EXTERNAL_LINK_OPTION = {
  label: 'External Link',
  value: EXTERNAL_OPTION_VALUE,
};

const createLinkFields = (
  links: string[],
  showExternalLink: boolean
): { link: SelectField; externalLink?: TextField } => ({
  link: {
    type: 'select',
    options: [
      { label: 'Select a link', value: '' },
      EXTERNAL_LINK_OPTION,
      ...links.map((link) => ({ label: link, value: link })),
    ],
  },
  ...(showExternalLink && {
    externalLink: {
      type: 'text',
      placeholder: 'https://example.com',
    },
  }),
});

export { createLinkFields, EXTERNAL_OPTION_VALUE };
